/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungserstellAntragDto } from '../../models/buchungserstell-antrag-dto';

export interface GetOffeneBuchungserstellAntraege$Json$Params {

/**
 * ID des Mitarbeiters, für den die offenen BuchungserstellAntraege geholt werden sollen
 */
  mitarbeiterId: string;
}

export function getOffeneBuchungserstellAntraege$Json(http: HttpClient, rootUrl: string, params: GetOffeneBuchungserstellAntraege$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungserstellAntragDto>>> {
  const rb = new RequestBuilder(rootUrl, getOffeneBuchungserstellAntraege$Json.PATH, 'get');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BuchungserstellAntragDto>>;
    })
  );
}

getOffeneBuchungserstellAntraege$Json.PATH = '/v1/mitarbeiter/{mitarbeiterId}/erstellAntraege/offen';
